import React, { useState, useEffect } from 'react';
import { Button, Dialog, Box, makeStyles, DialogTitle, DialogContent } from '@material-ui/core';
import { CircularProgress } from '@material-ui/core';
import { CustomToast } from '@jumbo/components/custom/Toast';


const addStyle = makeStyles(theme => ({
  dialogRoot: {
    position: 'relative',
  },
  dialogTitleRoot: {
    '& .MuiTypography-h6': {
      fontSize: 16,
      color: theme.palette.common.dark,
    },
  },
}));

const DeleteUserDialog = props => {
  const { openDialog = false, close, submit, userDelete } = props;
  const classes = addStyle();
  const [names, setNames] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (userDelete) {
      setNames(userDelete.user);
    } else {
      setNames('');
    }
  }, [userDelete]);

  const onCloseDialog = event => {
    if (loading) {
      event.preventDefault();
      return;
    }

    setLoading(false);
    close();
  };

  const onSubmitClick = () => {
    //setLoading(true);
    submit();
  };

  return (
    <Dialog open={openDialog} onClose={onCloseDialog}>
      <CustomToast />
      <DialogTitle className={classes.dialogTitleRoot}> Eliminar Usuario </DialogTitle>
      <DialogContent dividers>
        <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }} alignItems="center" mb={{ xs: 6, md: 5 }}>
          <p>Esta seguro que quiere eliminar a {names} </p>
        </Box>
        <Box display="flex" justifyContent="flex-end" mb={4}>
          <Button onClick={onCloseDialog} disabled={loading}>
            {' '}
            Cancelar{' '}
          </Button>
          <Box ml={2}>
            <Button variant="outlined" color="primary" onClick={onSubmitClick} disabled={loading}>
              {loading ? <CircularProgress color="inherit" style={{ height: '22px', width: '22px' }} /> : 'Eliminar'}
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteUserDialog;
